import useForm from './useForm'

export default function useDialog(emit, dialogProp) {
  const { formRef, loading, resetForm, resetFormValidation, validateForm, FORM_ERROR } = useForm()

  function closeDialog() {
    emit(`update:${dialogProp}`, false)
  }

  function emitRefetchData() {
    emit('refetch-data')
  }

  return {
    formRef,
    loading,
    resetForm,
    resetFormValidation,
    validateForm,
    FORM_ERROR,
    closeDialog,
    emitRefetchData,
  }
}
